export default {
  dataModel: {
    types: ['pair:Organization', 'pair:Person', 'pair:Event', 'cdlt:Course'],
  },
};
